module.exports = __webpack_public_path__ + "img/culture_1.efe3ce39.jpg";